<script lang="ts">
  import { EnumT } from "@shared/schema"
  import type { FormatSpec, GenericDataValue } from "@shared/types"
  import type { DataFormatOverrides } from "./types"

  export let textOnly: boolean = false
  export let value: GenericDataValue<EnumT.DataType.numberArray> | undefined
  export let formatSpec: FormatSpec
  export let dataFormatOverrides: DataFormatOverrides

  $: displayedValue = ((): string => {
    if (!value) {
      return ""
    }
    switch (formatSpec.type) {
      case EnumT.FormatSpecType.none:
        return value.join(", ")
      default:
        return `ERR: unsupported format type: ${formatSpec.type}`
    }
  })()
</script>

{#if value}
  {displayedValue}
{/if}
